import logoSvg from '@/assets/logo.svg';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
  className?: string;
}

const sizeMap = {
  sm: 'w-8 h-8',
  md: 'w-10 h-10',
  lg: 'w-12 h-12',
};

const textSizeMap = {
  sm: 'text-xl',
  md: 'text-2xl',
  lg: 'text-3xl',
};

const Logo = ({ size = 'sm', showText = true, className = '' }: LogoProps) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <img src={logoSvg} alt="Klipr" className={`${sizeMap[size]} rounded-xl`} />
      {showText && (
        <span className={`font-bold ${textSizeMap[size]} text-dark-800 dark:text-white`}>
          Klipr
        </span>
      )}
    </div>
  );
};

export default Logo;
